export const ROW_WITH_EXPAND_BUTTON_SPACING = 'rowWithExpandButtonSpacing'
export const SKIP_CELL_FOR_COPY = 'data-skip-copy'
